var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsFrontEdge;
(function (NsFrontEdge) {
    NsFrontEdge.command = XFlowEdgeCommands.FRONT_EDGE;
    NsFrontEdge.hookKey = 'frontEdge';
})(NsFrontEdge || (NsFrontEdge = {}));
let FrontEdgeCommand = 
/** 边前置命令(始终在画布最前方) */
class FrontEdgeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.frontEdge.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { edgeId } = handlerArgs;
                const x6Edge = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(edgeId);
                if (!x6Edge) {
                    console.error(edgeId, 'this edgeId is not exist');
                }
                else {
                    x6Edge.toFront();
                    /** frontEdge undo */
                    this.ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        handlerArgs.commandService.executeCommand(XFlowEdgeCommands.BACK_EDGE.id, {
                            edgeId,
                        });
                    })));
                }
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], FrontEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FrontEdgeCommand.prototype, "init", null);
FrontEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsFrontEdge.command.id },
    })
    /** 边前置命令(始终在画布最前方) */
], FrontEdgeCommand);
export { FrontEdgeCommand };
//# sourceMappingURL=edge-front.js.map